const config = {
  API: {
    GraphQL: {
      endpoint:        process.env.SHAKAPACKER_PUBLIC_APPSYNC_ENDPOINT,
      region:          process.env.SHAKAPACKER_PUBLIC_APPSYNC_REGION,
      defaultAuthMode: 'apiKey',
      apiKey:          process.env.SHAKAPACKER_PUBLIC_APPSYNC_API_KEY,
    },
  },
};

export default config;
